export const needPlatformRedirect = (license, currentPlatform) => {
  if (!license) return;
  if (license.type === currentPlatform) return false;
  return true;
};
